import React, { useState } from "react";

const TimeModal = ({ isOpen, onClose, onSave }) => {
  const [time, setTime] = useState("");

  function to12HourFormat(time24) {
    if (!time24) return "";

    const [hours24, minutes] = time24.split(":");
    const hours = parseInt(hours24, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = ((hours + 11) % 12) + 1;
    return `${hours12}:${minutes} ${suffix}`;
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-gray-900 bg-opacity-60 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="bg-white w-full sm:max-w-sm rounded-t-3xl sm:rounded-2xl p-5 shadow-2xl">
        <h2 className="text-lg font-bold text-gray-900">Set Pickup Time</h2>
        <p className="text-sm text-gray-500 mt-1 mb-4">
          Choose a pickup time in 5-minute increments.
        </p>
        <input
          type="time"
          step="300"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          className="input input-bordered w-full text-lg"
        />
        <div className="grid grid-cols-2 gap-3 mt-5">
          <button className="btn btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn bg-[#004a7e] text-white hover:bg-[#003a64] disabled:bg-gray-200 disabled:text-gray-400"
            disabled={!time}
            onClick={() => onSave(to12HourFormat(time))}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeModal;
